class KruxLoader {
    initKrux() {
        let krux = window.Krux;
        if(krux && !krux.user) {
            this.setKruxUserAndSegs();
        }
    }

    retrieve(n) {
        var k = 'kx' + 'foxnetworksgroup_' + n,
            ls = (function() {
                try {
                    return window.localStorage;
                } catch (e) {
                    return null;
                }
            })();
        if (ls) {
            return ls[k] || '';
        } else if (navigator.cookieEnabled) {
            var m = document.cookie.match(k + '=([^;]*)');
            return (m && unescape(m[1])) || '';
        } else {
            return '';
        }
    }

    /**
     * set user id and segments 
     */
    setKruxUserAndSegs() {
        window.Krux || ((Krux = function() { Krux.q.push(arguments); }).q = []);
        Krux.user = this.retrieve('user');
        Krux.segments = this.retrieve('segs') ? this.retrieve('segs').split(',') : [];
    }

}

export default new KruxLoader();


// WEBPACK FOOTER //
// ./assets/components/dmpKrux/KruxLoader.js